import React from 'react';

export default function FileProcessPanel({
  handleFileChange,
  handleFileUpload,
  loading,
  file,
  fileResult,
  handleExport
}) {
  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <label style={{ display: 'block', marginBottom: 5, fontWeight: 'bold' }}>选择文件</label>
        <input
          type="file"
          onChange={handleFileChange}
          accept=".gpx,.kml,.csv"
          style={{ padding: '8px' }}
        />
      </div>
      <button
        onClick={handleFileUpload}
        disabled={loading || !file}
        style={{
          padding: '10px 20px',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: loading || !file ? 'not-allowed' : 'pointer',
          opacity: loading || !file ? 0.6 : 1
        }}
      >
        {loading ? '解析中...' : '上传并解析'}
      </button>

      {fileResult && (
        <div style={{ marginTop: 20, padding: 15, background: '#f5f5f5', borderRadius: '4px' }}>
          <h4>文件解析结果</h4>
          {fileResult.error ? (
            <div style={{ color: 'red' }}>{fileResult.error}</div>
          ) : (
            <div>
              <div><strong>文件类型:</strong> {fileResult.type}</div>
              <div><strong>坐标数量:</strong> {fileResult.coordinates?.length || 0}</div>
              {fileResult.coordinates && fileResult.coordinates.length > 0 && (
                <button
                  onClick={() => handleExport(fileResult.coordinates, 'CSV', 'file_export')}
                  style={{ marginTop: 10, padding: '8px 16px', background: '#ff9800', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                  导出坐标
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
